import axios from 'axios'
import {BUSCAR_GRUPOS} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarGrupos() {
    const url = `${URL}/empresas/grupos/empresas`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_GRUPOS,
            payload: response

        })
    );
}
